import { postJson } from 'utils/http/postJson';

import { CmsApiReactionContext } from './types/CmsApiReactionContext';
import { CmsApiReactionType } from './types/CmsApiReactionType';

export async function cmsApiCreateReaction(
  pageId: string,
  reactionType: CmsApiReactionType,
) {
  const reactionContext = await postJson<CmsApiReactionContext>(
    `/data/website/reactions/cms-pages/${pageId}`,
    { reactionType },
  );

  return reactionContext;
}
